import { MultiSelect, MultiSelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { useBreakpoints } from "../../../utils/use-breakpoints"

interface Props extends Omit<MultiSelectProps, "value" | "onChange"> {
  value?: number[]
  onChange: (value: number[]) => void
}

export function SeasonMultiSelect({ value, onChange, ...props }: Props) {
  const { t } = useTranslation("app_server")
  const { xs } = useBreakpoints()
  return (
    <MultiSelect
      clearable
      pointer
      w={(props.w ?? xs) ? "100%" : 400}
      label={t("Seasons")}
      placeholder={value?.length ? "" : t("FilterSeasons")}
      value={value?.map((v) => v.toString())}
      onChange={(values) => onChange(values.map((v) => parseInt(v)))}
      {...props}
    />
  )
}
